export interface PonudbaPostavka {
  ime: string;
  kolicina?: string;
}

export interface PonudbaKategorija {
  id: string;
  stevilka: string;
  naslov: string;
  ikona: string;
  slika: string;
  postavke: PonudbaPostavka[];
}

export const ponudbaKategorije: PonudbaKategorija[] = [
  {
    id: "kava",
    stevilka: "01",
    naslov: "Kava",
    ikona: "ri-cup-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20small%20white%20coffee%20cup%20with%20latte%20art%20on%20a%20saucer%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20warm%20brown%20and%20gold%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20charming%20cafe%20character%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-kava-01&orientation=squarish",
    postavke: [
      { ime: "Kava" },
      { ime: "Americano" },
      { ime: "Kava z mlekom" },
      { ime: "Kava s smetano" },
      { ime: "Cappuccino" },
      { ime: "Macchiato" },
      { ime: "Bela kava" },
      { ime: "Mala bela kava" },
      { ime: "Latte macchiato" },
      { ime: "Ledena kava" },
      { ime: "Brezkofeinska kava" },
      { ime: "Brezkofeinska kava z mlekom" },
      { ime: "Brezkofeinska kava s smetano" },
      { ime: "Brezkofeinska bela kava" },
      { ime: "Brezkofeinski cappuccino" },
      { ime: "Brezkofeinski macchiato" },
    ],
  },
  {
    id: "topli-napitki",
    stevilka: "02",
    naslov: "Topli napitki",
    ikona: "ri-fire-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20steaming%20mug%20of%20hot%20cocoa%20with%20a%20cinnamon%20stick%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20warm%20brown%20and%20amber%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20cozy%20winter%20cafe%20character%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-topli-02&orientation=squarish",
    postavke: [
      { ime: "Kakav" },
      { ime: "Kuhani gin" },
      { ime: "Topla limonada" },
    ],
  },
  {
    id: "brezalkoholne-pijace",
    stevilka: "03",
    naslov: "Brezalkoholne pijače",
    ikona: "ri-water-flash-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20tall%20glass%20of%20sparkling%20lemonade%20with%20bubbles%2C%20two%20straws%20and%20a%20lemon%20slice%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20fresh%20citrus%20yellow%20and%20soft%20green%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-brezalkoholne-03&orientation=squarish",
    postavke: [
      { ime: "Coca-Cola", kolicina: "0,10 l" },
      { ime: "Coca-Cola", kolicina: "0,25 l" },
      { ime: "Cockta", kolicina: "0,25 l" },
      { ime: "Fanta", kolicina: "0,25 l" },
      { ime: "Sprite", kolicina: "0,35 l" },
      { ime: "Orangina", kolicina: "0,25 l" },
      { ime: "Cedevita" },
      { ime: "Ledeni čaj", kolicina: "0,33 l" },
      { ime: "Ledeni čaj Monin" },
      { ime: "Lemonish", kolicina: "0,33 l" },
      { ime: "Limonada" },
      { ime: "Malinovec" },
      { ime: "Naravni sok", kolicina: "0,10 l" },
      { ime: "Naravni sok", kolicina: "0,20 l" },
      { ime: "Ora", kolicina: "0,10 l" },
      { ime: "Sok", kolicina: "0,10 l" },
      { ime: "Sok Fructal", kolicina: "0,25 l" },
      { ime: "Radenska", kolicina: "0,10 l" },
      { ime: "Radenska", kolicina: "0,25 l" },
      { ime: "Radenska", kolicina: "1 l" },
      { ime: "Römerquelle", kolicina: "0,33 l" },
      { ime: "Schweppes", kolicina: "0,10 l" },
      { ime: "Schweppes", kolicina: "0,25 l" },
      { ime: "Red Bull", kolicina: "0,25 l" },
    ],
  },
  {
    id: "piva",
    stevilka: "04",
    naslov: "Piva",
    ikona: "ri-beer-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20tall%20beer%20glass%20filled%20with%20golden%20beer%20and%20a%20thick%20creamy%20foam%20head%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20warm%20amber%20and%20gold%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-pivo-04&orientation=squarish",
    postavke: [
      { ime: "Laško", kolicina: "0,33 l" },
      { ime: "Laško", kolicina: "0,50 l" },
      { ime: "Laško 0,0" },
      { ime: "Heineken", kolicina: "0,33 l" },
      { ime: "Heineken 0,0" },
      { ime: "Corona", kolicina: "0,33 l" },
      { ime: "Ožujsko", kolicina: "0,33 l" },
      { ime: "Salitos", kolicina: "0,33 l" },
      { ime: "Smile", kolicina: "0,33 l" },
      { ime: "Malt", kolicina: "0,33 l" },
      { ime: "Radler", kolicina: "0,50 l" },
      { ime: "Točeno pivo", kolicina: "0,10 l" },
      { ime: "Točeno pivo", kolicina: "0,20 l" },
      { ime: "Točeno pivo", kolicina: "0,30 l" },
      { ime: "Točeno pivo", kolicina: "0,50 l" },
    ],
  },
  {
    id: "vina",
    stevilka: "05",
    naslov: "Vina",
    ikona: "ri-leaf-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20stemmed%20wine%20glass%20with%20deep%20red%20wine%20and%20a%20small%20vine%20leaf%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20burgundy%20and%20soft%20green%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-vino-05&orientation=squarish",
    postavke: [
      { ime: "Haložan", kolicina: "0,10 l" },
      { ime: "Haložan", kolicina: "1 l" },
      { ime: "Gorjak", kolicina: "0,10 l" },
      { ime: "Cviček", kolicina: "0,10 l" },
      { ime: "Refošk", kolicina: "0,10 l" },
      { ime: "Bambus", kolicina: "0,20 l" },
      { ime: "Cviček špricar", kolicina: "0,20 l" },
      { ime: "Belo kuhano vino", kolicina: "0,20 l" },
      { ime: "Rdeče kuhano vino", kolicina: "0,20 l" },
    ],
  },
  {
    id: "desertna-vina",
    stevilka: "06",
    naslov: "Desertna vina in aperitivi",
    ikona: "ri-goblet-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20small%20dessert%20wine%20glass%20with%20amber%20liquid%20beside%20a%20few%20grapes%20and%20an%20apricot%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20honey%20amber%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-desertno-vino-06&orientation=squarish",
    postavke: [
      { ime: "Cabernet Sauvignon", kolicina: "0,10 l" },
      { ime: "Rumeni muškat", kolicina: "0,10 l" },
      { ime: "Sauvignon Pullus", kolicina: "0,10 l" },
      { ime: "Sladki refošk", kolicina: "0,10 l" },
      { ime: "Martini Bianco", kolicina: "0,10 l" },
      { ime: "Martini Extra Dry", kolicina: "0,10 l" },
    ],
  },
  {
    id: "penine",
    stevilka: "07",
    naslov: "Penine",
    ikona: "ri-star-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20slender%20champagne%20flute%20with%20sparkling%20wine%20and%20rising%20bubbles%20plus%20a%20tiny%20star%20accent%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20pale%20gold%20and%20cream%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-penina-07&orientation=squarish",
    postavke: [
      { ime: "Penina", kolicina: "0,10 l" },
      { ime: "Penina", kolicina: "0,20 l" },
      { ime: "Penina", kolicina: "0,75 l" },
    ],
  },
  {
    id: "koktajli",
    stevilka: "08",
    naslov: "Koktajli in trendovske pijače",
    ikona: "ri-goblet-fill",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20round%20cocktail%20glass%20with%20orange%20drink%2C%20ice%20cubes%2C%20orange%20slice%20and%20a%20straw%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20vivid%20orange%20and%20coral%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-koktajl-08&orientation=squarish",
    postavke: [
      { ime: "Aperol Spritz" },
      { ime: "Spritz" },
      { ime: "Mojito" },
      { ime: "Cuba Libre" },
      { ime: "Hugo", kolicina: "0,15 l" },
      { ime: "Into the Blue" },
      { ime: "Martini Bianco Tonik" },
      { ime: "Martini Extra Dry & Tonik" },
      { ime: "Martini Fiero & Tonic" },
      { ime: "Kamikaza", kolicina: "0,03 l" },
      { ime: "Skinny Beach" },
    ],
  },
  {
    id: "whisky",
    stevilka: "09",
    naslov: "Whisky",
    ikona: "ri-moon-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20short%20tumbler%20glass%20with%20amber%20whisky%20and%20a%20single%20ice%20cube%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20rich%20caramel%20and%20copper%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20elegant%20evening%20mood%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-whisky-09&orientation=squarish",
    postavke: [
      { ime: "Ballantine's", kolicina: "0,03 l" },
      { ime: "Canadian Club (C.C.)", kolicina: "0,03 l" },
      { ime: "Chivas", kolicina: "0,03 l" },
      { ime: "Jack Daniel's", kolicina: "0,03 l" },
      { ime: "Jameson", kolicina: "0,03 l" },
      { ime: "Screwball", kolicina: "0,03 l" },
      { ime: "Shanky", kolicina: "0,03 l" },
    ],
  },
  {
    id: "zgane-pijace",
    stevilka: "10",
    naslov: "Žgane pijače in likerji",
    ikona: "ri-drop-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20small%20shot%20glass%20with%20clear%20spirit%20next%20to%20a%20tiny%20rounded%20bottle%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20soft%20olive%20green%20and%20cream%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-zgane-10&orientation=squarish",
    postavke: [
      { ime: "Amaro", kolicina: "0,03 l" },
      { ime: "Bacardi", kolicina: "0,03 l" },
      { ime: "Baileys", kolicina: "0,03 l" },
      { ime: "Borovničke", kolicina: "0,03 l" },
      { ime: "Campari", kolicina: "0,03 l" },
      { ime: "Carolans", kolicina: "0,03 l" },
      { ime: "Diplomatico", kolicina: "0,03 l" },
      { ime: "Gin", kolicina: "0,03 l" },
      { ime: "Hruškov liker", kolicina: "0,03 l" },
      { ime: "Jägermeister", kolicina: "0,03 l" },
      { ime: "Malibu", kolicina: "0,03 l" },
      { ime: "Mentol", kolicina: "0,03 l" },
      { ime: "Orehovec", kolicina: "0,03 l" },
      { ime: "Pelinkovec", kolicina: "0,03 l" },
      { ime: "Pelinkovec Antique", kolicina: "0,33 l" },
      { ime: "Puškin", kolicina: "0,03 l" },
      { ime: "Rum", kolicina: "0,03 l" },
      { ime: "Rum Barceló Imperial", kolicina: "0,03 l" },
      { ime: "Rum Bumbu", kolicina: "0,03 l" },
      { ime: "Stock", kolicina: "0,03 l" },
      { ime: "Tavžent roža", kolicina: "0,03 l" },
      { ime: "Tekila", kolicina: "0,03 l" },
      { ime: "Tekila Mandelj", kolicina: "0,03 l" },
      { ime: "Travarica", kolicina: "0,03 l" },
      { ime: "Ultimus Pelinkovec", kolicina: "0,03 l" },
    ],
  },
  {
    id: "dodatki",
    stevilka: "11",
    naslov: "Dodatki in ostalo",
    ikona: "ri-add-line",
    slika:
      "https://readdy.ai/api/search-image?query=Playful%20cartoon%20illustration%20of%20a%20small%20milk%20jug%20with%20a%20lemon%20slice%20and%20a%20honey%20jar%2C%20flat%20hand%20drawn%20vector%20style%2C%20plain%20cream%20beige%20background%2C%20soft%20cream%20and%20pale%20yellow%20tones%2C%20simple%20clean%20lines%2C%20centered%20composition%2C%20no%20text%2C%20soft%20rounded%20shapes&width=240&height=240&seq=meni-ilustracija-dodatki-11&orientation=squarish",
    postavke: [
      { ime: "Babyccino" },
      { ime: "Limona" },
      { ime: "Med" },
      { ime: "Mleko" },
      { ime: "Rastlinsko mleko" },
      { ime: "Smetana" },
      { ime: "Lonček TO-GO" },
    ],
  },
];